import { Link } from "react-router-dom";
import { LogOut, ShieldCheck, ClipboardList, Workflow } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function TopBar({ right }) {
  const { user, logout } = useAuth();
  return (
    <header className="brand-band text-white">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-3.5 flex items-center justify-between gap-4">
        <Link to="/IAMquestionnaire" className="flex items-center gap-3 min-w-0">
          <span className="section-badge" style={{ background: "rgba(255,255,255,0.14)" }}>
            <ShieldCheck className="w-5 h-5" />
          </span>
          <div className="min-w-0">
            <p className="text-[11px] tracking-[0.22em] text-amber-200/90 font-semibold uppercase leading-none">
              MikadoComms
            </p>
            <p className="text-sm font-semibold truncate">Wema Bank IAM Profiling</p>
          </div>
        </Link>
        <div className="flex items-center gap-3">
          {right}
          {user && (
            <Link to="/responses" data-testid="nav-responses-link" className="hidden sm:inline-flex items-center gap-1 text-sm text-white/80 hover:text-white">
              <ClipboardList className="w-4 h-4" /> Responses
            </Link>
          )}
          {user && (
            <Link to="/onboarding" data-testid="nav-onboarding-link" className="hidden sm:inline-flex items-center gap-1 text-sm text-white/80 hover:text-white">
              <ClipboardList className="w-4 h-4" /> Onboarding
            </Link>
          )}
          {(user?.role === "admin" || user?.role === "operator") && (
            <Link to="/orchestration" data-testid="nav-orchestration-link" className="hidden sm:inline-flex items-center gap-1 text-sm text-white/80 hover:text-white">
              <Workflow className="w-4 h-4" /> Orchestration
            </Link>
          )}
          {user?.role === "admin" && (
            <Link to="/admin" data-testid="nav-admin-link" className="hidden sm:inline text-sm text-white/80 hover:text-white">
              Admin
            </Link>
          )}
          <span className="hidden md:inline text-sm text-white/70 truncate max-w-[180px]">{user?.email}</span>
          <button data-testid="logout-btn" onClick={logout} className="btn btn-outline !text-white !border-white/30 hover:!bg-white/10 !py-1.5 !px-3">
            <LogOut className="w-4 h-4" /> <span className="hidden sm:inline">Sign out</span>
          </button>
        </div>
      </div>
    </header>
  );
}
